const resetPasswordEndpointParamsSchema = (password, confirmPassword, token) => ({
  password,
  password_confirmation: confirmPassword,
  token,
});

export default resetPasswordEndpointParamsSchema;
